/* Iceman 2026 購物車頁：改數量、改尺寸、移除、改成組合、空車加購。
   每次改完都用 Section Rendering API 拿回整個區塊，只換掉 data-ic-r 的區域（AKO 發票區塊、結帳按鈕不動）。
   「前往結算」是一般表單送出（name="checkout"），OS 加購視窗、AKO 都照原本方式接手。 */
(function () {
  var root = document.querySelector('[data-icart]');
  if (!root) return;
  var sid = root.getAttribute('data-sid');
  var form = root.querySelector('[data-ic-form]');
  var toastEl = root.querySelector('[data-ic-toast]');
  var ui = { how: false, edit: null, editVid: null };
  var busy = false, toastTimer;

  function $(sel, el) { return (el || root).querySelector(sel); }
  function $$(sel, el) { return Array.prototype.slice.call((el || root).querySelectorAll(sel)); }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) { if (!r.ok) throw j; return j; });
    });
  }
  function withSec(body) { body.sections = [sid]; body.sections_url = '/cart'; return body; }

  function refresh() {
    // 不能帶 Accept: application/json，不然 /cart 會回購物車資料而不是區塊 HTML
    return fetch('/cart?sections=' + encodeURIComponent(sid))
      .then(function (r) { return r.json(); })
      .then(function (j) { if (j && j[sid]) apply(j[sid]); else window.location.reload(); });
  }

  // 換掉會變的區域，其他（AKO、結帳按鈕）留著
  function apply(html) {
    if (!html) return refresh();
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var nr = doc.querySelector('[data-icart]');
    if (!nr) { window.location.reload(); return; }
    $$('[data-ic-r]').forEach(function (el) {
      var n = nr.querySelector('[data-ic-r="' + el.getAttribute('data-ic-r') + '"]');
      if (n) { el.innerHTML = n.innerHTML; el.hidden = n.hidden; }
    });
    var cnt = parseInt(nr.getAttribute('data-count'), 10) || 0;
    root.setAttribute('data-count', cnt);
    form.hidden = cnt === 0;
    document.querySelectorAll('[data-header-cart-count]').forEach(function (el) {
      el.setAttribute('data-header-cart-count', cnt);
      el.textContent = cnt;
    });
    restore();
  }

  // 「怎麼算」、改尺寸面板的開關狀態在重畫後接回來
  function restore() {
    var how = $('[data-ic-how]'), txt = $('[data-ic-howtext]');
    if (how && txt) { how.setAttribute('aria-expanded', ui.how ? 'true' : 'false'); txt.hidden = !ui.how; }
    if (ui.editVid) {
      var nl = $('[data-ic-line][data-vid="' + ui.editVid + '"]');
      ui.edit = nl ? nl.getAttribute('data-key') : null;
      ui.editVid = null;
    }
    $$('[data-ic-line]').forEach(function (l) {
      var on = l.getAttribute('data-key') === ui.edit;
      var b = $('[data-ic-edit]', l), ed = $('[data-ic-ed]', l);
      if (b) b.setAttribute('aria-expanded', on ? 'true' : 'false');
      if (ed) ed.hidden = !on;
    });
  }

  function toast(t) {
    clearTimeout(toastTimer);
    toastEl.hidden = true;
    toastEl.textContent = t;
    void toastEl.offsetWidth;
    toastEl.hidden = false;
    toastTimer = setTimeout(function () { toastEl.hidden = true; }, 2200);
  }
  function errText(e) { return (e && (e.description || e.message)) || '沒有更新成功，請再試一次'; }

  function run(task) {
    if (busy) return;
    busy = true;
    root.classList.add('is-busy');
    Promise.resolve().then(task)
      .catch(function (e) { toast(errText(e)); return refresh(); })
      .catch(function () {})
      .then(function () { busy = false; root.classList.remove('is-busy'); });
  }
  function sec(c) { return c && c.sections ? c.sections[sid] : null; }

  // 這一列的商品屬性（例如 OS 加購標記 _icm_up）：Liquid 的 json 會輸出成 [["鍵","值"],…]，沒有屬性是 []
  function propsOf(l) {
    var p = null, o = {};
    try { p = JSON.parse((l && l.getAttribute('data-props')) || 'null'); } catch (x) { p = null; }
    if (Array.isArray(p)) p.forEach(function (kv) { if (kv && kv.length === 2 && kv[1] != null && kv[1] !== '') o[kv[0]] = kv[1]; });
    else if (p && typeof p === 'object') o = p;
    return Object.keys(o).length ? o : null;
  }

  // 改尺寸：單件先加新的（失敗就什麼都不動）再拿掉原本那條；
  // 組合是 Shopify 組合商品，跟原本那條共用項鍊／手鍊的庫存 → 先拿掉再加，加不進去就放回去
  function pick(l, t) {
    var vid = t.getAttribute('data-ic-pick'), key = l.getAttribute('data-key');
    var isSet = l.getAttribute('data-kind') === 's';
    if (!vid) return;
    if (t.classList.contains('is-on')) { if (!isSet) { ui.edit = null; restore(); } return; }
    var props = propsOf(l), q = parseInt(l.getAttribute('data-qty'), 10) || 1;
    var add = { id: +vid, quantity: q }, back = { id: +l.getAttribute('data-vid'), quantity: q };
    if (props) { add.properties = props; back.properties = props; }
    run(function () {
      var done = isSet
        ? post('/cart/change.js', { id: key, quantity: 0 }).then(function () {
            return post('/cart/add.js', withSec({ items: [add] })).catch(function (e) {
              return post('/cart/add.js', { items: [back] }).then(function () { throw e; }, function () { throw e; });
            });
          })
        : post('/cart/add.js', { items: [add] }).then(function () { return post('/cart/change.js', withSec({ id: key, quantity: 0 })); });
      return done.then(function (c) { ui.edit = null; ui.editVid = isSet ? vid : null; apply(sec(c)); });
    });
  }

  function setQty(l, q, done) {
    run(function () {
      return post('/cart/change.js', withSec({ id: l.getAttribute('data-key'), quantity: q }))
        .then(function (c) { apply(sec(c)); if (done) done(); });
    });
  }

  // 改成組合：組合跟項鍊／手鍊共用庫存 → 先各拿掉一件再加組合，加不進去就放回去
  function merge(t) {
    var u = {};
    u[t.getAttribute('data-n')] = (parseInt(t.getAttribute('data-nq'), 10) || 1) - 1;
    u[t.getAttribute('data-b')] = (parseInt(t.getAttribute('data-bq'), 10) || 1) - 1;
    var back = [{ id: +t.getAttribute('data-nv'), quantity: 1 }, { id: +t.getAttribute('data-bv'), quantity: 1 }];
    [t.getAttribute('data-n'), t.getAttribute('data-b')].forEach(function (k, i) {
      var pl = propsOf($('[data-ic-line][data-key="' + k + '"]')); if (pl) back[i].properties = pl; });
    var save = t.getAttribute('data-save');
    run(function () {
      return post('/cart/update.js', { updates: u })
        .then(function () {
          return post('/cart/add.js', withSec({ items: [{ id: +t.getAttribute('data-set'), quantity: 1 }] })).catch(function (e) {
            return post('/cart/add.js', { items: back }).then(function () { throw e; }, function () { throw e; });
          });
        })
        .then(function (c) { ui.edit = null; apply(sec(c)); toast('已改成組合，省 ' + save); });
    });
  }

  root.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('button') : null;
    if (!t || !root.contains(t) || t.name === 'checkout' || t.disabled) return;
    var l = t.closest('[data-ic-line]');
    if (t.hasAttribute('data-ic-how')) { ui.how = !ui.how; restore(); return; }
    if (t.hasAttribute('data-ic-edit') && l) {
      var k = l.getAttribute('data-key');
      ui.edit = ui.edit === k ? null : k;
      restore();
      return;
    }
    if (t.hasAttribute('data-ic-done')) { ui.edit = null; restore(); return; }
    if (t.hasAttribute('data-ic-pick') && l) { pick(l, t); return; }
    if ((t.hasAttribute('data-ic-dec') || t.hasAttribute('data-ic-inc')) && l) {
      var q = (parseInt(l.getAttribute('data-qty'), 10) || 1) + (t.hasAttribute('data-ic-inc') ? 1 : -1);
      if (q >= 1) setQty(l, q);
      return;
    }
    if (t.hasAttribute('data-ic-rm') && l) {
      var name = l.getAttribute('data-name');
      if (ui.edit === l.getAttribute('data-key')) ui.edit = null;
      setQty(l, 0, function () { toast('已移除 ' + name); });
      return;
    }
    if (t.hasAttribute('data-ic-merge')) { merge(t); return; }
    if (t.hasAttribute('data-ic-add')) {
      run(function () {
        return post('/cart/add.js', withSec({ items: [{ id: +t.getAttribute('data-ic-add'), quantity: 1 }] }))
          .then(function (c) { apply(sec(c)); toast('已加入購物車'); });
      });
    }
  });

  // AKO 的發票區塊會插在 id="checkout" 按鈕前面 → 搬到「索取發票」的位置（之後 AKO 自己重畫也不影響）
  function placeAko() {
    var slot = $('[data-ako-slot]'), s = document.getElementById('akocommerce_cvs_section');
    if (!slot || !s) return;
    var holder = s.parentNode;
    if (holder && holder !== slot && holder.parentNode !== slot && root.contains(holder)) slot.appendChild(holder);
  }
  placeAko();
  if (window.MutationObserver) new MutationObserver(placeAko).observe(root, { childList: true, subtree: true });

  // 從別頁返回（bfcache）時購物車可能變了
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });

  restore();
})();
